<template>

  <div>
    <div v-if="+this.$store.getters.loginUser.comtype === 1">
      <vggrid ref="xGrid" :list="list" tableheight="500" flexname=""
              :cols="cols" :showfooter="false" :resizable="true"
              :needBlackRow="false"  :canbeEdit="true"
              :editRules="editRules">
        <template slot="btn">
          <div>
          <vxe-button type="primary" class="vxe-btn" @click="savePsu" :loading="btnLoading">提交</vxe-button>
          </div>
        </template>
      </vggrid>
    </div>
    <div v-else>
      <vggrid ref="xGrid" :list="list" tableheight="500" flexname=""
              :cols="colst" :showfooter="false" :resizable="true"
              :needBlackRow="false"  :canbeEdit="true"
              :editRules="editRules">
        <template slot="btn">
          <div>
          <vxe-button type="primary" class="vxe-btn" @click="purchaSesavePsu" :loading="btnLoading">确认</vxe-button>
          </div>
        </template>
      </vggrid>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  /* eslint-disable */
  export default {
    name: 'pbidcomfirmfeeamtfrom',
    props: {
      projectid: {},
      list: {
        default: [],
        type:Array
      }
    },
    data () {
      return {
        comList:[],
        project: this.$route.params.form,
        cols: [
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '经办人',calculExpr:'',addNewRowFlg: false, width: 200 },
          // {field: 'psuoffertime', fieldtype: 'C', title: '报价时间', calculExpr: '', addNewRowFlg: false},
          { field: 'psufeeamt',fieldtype: 'C', title: '服务费',calculExpr:'', width: 100},
          // { field: 'psuconfirmfeeamt', fieldtype: 'F', title: '确认服务费',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}},
          { title: '确认服务费 ', showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                  return [
                    <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                  value={row.psuconfirmfeeamt}  onChange={this.inputChange.bind(this, row)}></input>
                ]
              }
            }
          }
        ],
        colst:[
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '经办人',calculExpr:'',addNewRowFlg: false, width: 200 },
          // {field: 'psuoffertime', fieldtype: 'C', title: '报价时间', calculExpr: '', addNewRowFlg: false},
        ],
        editRules: {
          'psuconfirmfeeamt': [
            {required: true, message: '输入内容不能为空'},
            {max: 40, message: '最多输入40个字符'}
          ]
        },
        loading: true,
        btnLoading: false,
        formLabelWidth: '100px',
        disable: false
      }
    },
    created () {
    },
    activated() {
      // this.init()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      inputChange (row, e) {
        let float = /^([+-]?)\d*\.\d+$|(^[0-9]\d*$)/
        if (e.target.value && !(float.test(e.target.value))) {
          this.$message.warning('请输入正确的服务费！')
          e.target.value = ''
        } 
        // else if(Number(e.target.value) <= 0) {
        //   this.$message.warning('服务费必须大于0！')
        //   e.target.value = ''
        // }
        row.psuconfirmfeeamt = e.target.value
      },
      async purchaSesavePsu (){
          let model = {
            psuList: this.list,
            projectid: this.project.projectid,
            userid: this.$store.getters.loginUser.userid
          }
          let data = await request({
              url: '/xmgl/project/savePbidConfirm',
              method: "post",
              data: model
            })
          if (data.issuccess === 1) {
            this.$message.success('确认成交成功！')
            this.$emit('close')
          } else {
            this.$message.success('确认成交失败！')
          }
      },
      async savePsu () {
        let index = this.list.findIndex(v => +v.psuconfirmfeeamt < 0)
        if (index !== -1) {
          this.$message.warning('请输入正确的服务费！')
          return
        }
  
        // if(+this.project.prschangeflg === 1){
        //     let index = this.list.findIndex(e => e.psuconfirmfeeamt<500)
        //     if (index !== -1) {
        //       this.$message.warning('服务费不能小于500！')
        //       return
        //     }
        // }
        this.$confirm('请核对【确认服务费】的金额是否正确，如确认无误，提交后将不能修改，是否继续？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
          let model = {
            psuList: this.list,
            projectid: this.project.projectid,
            userid: this.$store.getters.loginUser.userid
          }
          let data = await
            request({
              url: '/xmgl/project/savePbidConfirm',
              method: "post",
              data: model
            })
          if (data.issuccess === 1) {
            this.$message.success('确认成交成功！')
            this.$emit('close')
          } else {
            this.$message.success('确认成交失败！')
          }
        }).catch(() => {

        })

      }
    },
    filters: {
    }
  }
</script>

<style lang="scss">
  .btn {
    padding-left: 10px;
  }

</style>
